




































import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { getTxChainType } from '@/known_blockchains'

@Component({})
export default class TransactionResult extends Vue {
    @Prop() item!: any

    select() {
        this.$router.push(`/tx/${this.item.id}`)
        this.$emit('select')
    }

    get chainColor() {
        return getTxChainType(this.item.chainID)!.color
    }

    get chainDarkColor() {
        return getTxChainType(this.item.chainID)!.darkColor
    }

    get chainName() {
        return getTxChainType(this.item.chainID)!.name
    }
}
